import { inject, Injectable, signal } from '@angular/core';
import { LocalStorageService } from '@insolution/store-data-access';

const SEEN_ANNOUNCEMENTS_STORAGE_KEY = 'announcements_seen';

@Injectable({
  providedIn: 'root',
})
export class SeenAnnouncementsService {
  private localStorageService = inject(LocalStorageService);

  public seenAnnouncementIds = signal<string[]>(
    this.localStorageService.getItem<string[]>(SEEN_ANNOUNCEMENTS_STORAGE_KEY) ?? []
  );

  public markAnnouncementAsSeen(announcementId: string): void {
    const seenAnnouncementIds = [...this.seenAnnouncementIds(), announcementId];

    this.seenAnnouncementIds.set(seenAnnouncementIds);
    this.localStorageService.storeItem(SEEN_ANNOUNCEMENTS_STORAGE_KEY, seenAnnouncementIds);
  }

  public resetSeenAnnouncements(): void {
    this.seenAnnouncementIds.set([]);
    this.localStorageService.removeItem(SEEN_ANNOUNCEMENTS_STORAGE_KEY);
  }
}
